
<app-back-navigation [backTitle]="'buttons.back'" (onClickBack)="goBack()"></app-back-navigation>
<app-case-form-section-container [iconClass]="'bi bi-collection'" [title]="'label.document_library'">
    <app-dynamic-table
    *ngIf="isDataTableReady"
    [columns]="columns"
    [rows]="cases"
    [defaultColumns]="defaultColumns"
    [selectedFilterName]="selectedFilterName"
    [useExternalApi]="true"
    [totalCount]="totalCount"
    [dataTableState]="dataTableState"
    (dataTableStateEvent)="getDataTableState($event)"
    (actionButtonEvent)="actionButton($event)"
    (linkedValueClickEvent)="onLinkedValueClick($event)"
    [filters]="filters"
    [showSaveDatatableFilterBtn]="true"
    [gridSettingsChanged]="!!datatableStateFromStorage"
    (saveDataTableSettingsEvent)="onSaveDatatableSettings($event)"
    (updateDataTableSettingsEvent)="onUpdateDatatableSettings($event)"
    [showColumnsSettingsBtn]="false"
  ></app-dynamic-table>
</app-case-form-section-container>